 export const TRANSFORM_USER = (rawUser: any): User => {
    return {
      is_new_user: rawUser.is_new_user,
      consent: rawUser.consent,
      id: rawUser.id,
      email: rawUser.email,
      name: rawUser.name,
      profileImage: rawUser.profileImage,
      club: {
        id: rawUser.club?.id,
        name: rawUser.club?.name,
        image: rawUser.club?.image,
        instituteId: rawUser.club?.instituteId,
        instituteTypeId: rawUser.club?.instituteTypeId,
      },
      bio: rawUser.bio,
      coursesId: rawUser.coursesId,
      homePageImage: rawUser.homePageImage,
      date_of_birth: rawUser.date_of_birth,
      cvOverview: {},
      fromControlCenter: rawUser.fromControlCenter,
      FAno: rawUser.FAno,
      PFAno: rawUser.PFAno,
      NIno: rawUser.NIno,
      footballAttribute: rawUser.footballAttribute,
      topLevelVideos: rawUser.topLevelVideos,
      transferableValues: {
        assertiveness: {
          point: rawUser.transferableValues?.assertiveness?.point,
          comment: rawUser.transferableValues?.assertiveness?.comment,
        },
        adaptability: {
          point: rawUser.transferableValues?.adaptability?.point,
          comment: rawUser.transferableValues?.adaptability?.comment,
        },
        // Continue for the other transferable values...
      },
      boxToBox: rawUser.boxToBox,
      cv: rawUser.cv,
      cvFiles: rawUser.cvFiles,
      footballMedia: rawUser.footballMedia,
      createdAt: rawUser.createdAt,
      isArchived: rawUser.isArchived,
      status: rawUser.status,
      _rid: rawUser._rid,
      _self: rawUser._self,
      _etag: rawUser._etag,
      _attachments: rawUser._attachments,
      playerCategory: rawUser.playerCategory,
      password: rawUser.password,
      isLogout: rawUser.isLogout,
      _ts: rawUser._ts,
      isFootballAttribute: rawUser.isFootballAttribute,
      videoList: rawUser.videoList,
      userProfile: rawUser.userProfile,
      userDynamicProfile: rawUser.userDynamicProfile,
      // Billing state — the paywall reads these straight after login, before
      // the server refresh lands.
      accountType: rawUser.accountType,
      accountStatus: rawUser.accountStatus,
      subscriptionStatus: rawUser.subscriptionStatus,
      subscriptionExpiry: rawUser.subscriptionExpiry,
      subscriptionPlan: rawUser.subscriptionPlan,
      pastDueSince: rawUser.pastDueSince,
      cancelAtPeriodEnd: rawUser.cancelAtPeriodEnd,
      // login returns the raw doc, getUser returns the derived boolean.
      hasBilling: !!(rawUser.stripeCustomerId || rawUser.hasBilling),
    };
  };
  